import {http, getApiUrl } from './request'
// import axios from 'axios'

// export const reqlogin = payload => {
//     return http.post("http://yapi.driverglobe.com/mock/13/login/common/pwd", payload)
// }



export const  reqlogin = (payload) => {
    return http.post(getApiUrl('/duckbill-agent-tms/user/login'), payload);
}
